"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForegroundCircle = exports.BackgroundCircle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BackgroundCircle = exports.BackgroundCircle = _styledComponents["default"].circle.withConfig({
  displayName: "styles__BackgroundCircle",
  componentId: "sc-bxqd29-0"
})(["fill:none;stroke:#c4c4c4;"]);
var ForegroundCircle = exports.ForegroundCircle = _styledComponents["default"].circle.withConfig({
  displayName: "styles__ForegroundCircle",
  componentId: "sc-bxqd29-1"
})(["fill:none;stroke:", ";transform:rotate(-90deg);transform-origin:50% 50%;transition:0.2s stroke-dashoffset ease-out;"], _palette.commonPalette.sgGreen);
//# sourceMappingURL=styles.js.map